<template>
  <div style="text-align:center;margin-top:5px">
   <p><a target="_bank" style="color: #999999;text-decoration: none" href="https://beian.miit.gov.cn">蜀ICP备20012822号-2</a></p>
   <p>© 2020 四川蓝韵心理咨询服务有限公司 <span style="margin-left: 10px;">成都丰捷信科技有限公司</span></p>
   <!-- <p>© 2020 成都丰捷信科技有限公司</p> -->
  </div>
</template>

<script>
export default {
  name: "bottom"
};
</script>

<style scoped>
p {
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Footer/bottom.vue